import { canUseDOM } from 'exenv'

export const PCLN_BOOTSTRAP_DATA = canUseDOM && window.PCLN_BOOTSTRAP_DATA
  ? window.PCLN_BOOTSTRAP_DATA
  : { webstats: {}, referral: {} }
